import ReactEChartsCore from "echarts-for-react/lib/core";
import * as echarts from "echarts/core";
import { GaugeChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([GaugeChart, CanvasRenderer]);

interface ScoreGaugeProps {
  score: number;
  size?: number;
}

export function ScoreGauge({ score, size = 200 }: ScoreGaugeProps) {
  const option = {
    series: [
      {
        type: "gauge",
        startAngle: 200,
        endAngle: -20,
        min: 0,
        max: 100,
        radius: "100%",
        pointer: { show: false },
        progress: {
          show: true,
          width: 14,
          roundCap: true,
          itemStyle: {
            color: score > 70 ? "#22c55e" : score > 50 ? "#f59e0b" : score > 25 ? "#f97316" : "#ef4444",
          },
        },
        axisLine: { lineStyle: { width: 14, color: [[1, "#e2e8f0"]] } },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        detail: {
          valueAnimation: true,
          fontSize: 28,
          fontWeight: 700,
          color: "#0f172a",
          offsetCenter: [0, "10%"],
          formatter: "{value}",
        },
        title: {
          fontSize: 12,
          color: "#94a3b8",
          offsetCenter: [0, "40%"],
        },
        data: [{ value: score, name: "Health Score" }],
      },
    ],
  };

  return <ReactEChartsCore echarts={echarts} option={option} style={{ height: size, width: size }} />;
}
